<template>
    <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
            <div class="card bg-secondary shadow border-0">
                <div class="card-body px-lg-5 pt-lg-5">
                    <form role="form" ref="form" :model="form">

                        <div class="form-group input-group-alternative mb-3 input-group">
                            <div class="input-w-icon">
                                <span><i class="ni ni-badge"></i></span>
                                <input class="form-control" placeholder="Identificador" v-model="form.identificador" ref="identificador"></input>
                            </div>
                        </div>

                        <div class="form-group input-group-alternative mb-3 input-group">
                            <div class="input-w-icon">
                                <span><i class="ni ni-hat-3"></i></span>
                                <input class="form-control" placeholder="Nombre" v-model="form.nombre" ref="nombre"></input>
                            </div>
                        </div>

                        <div class="form-group input-group-alternative mb-3 input-group">
                            <div class="input-w-icon">
                                <span><i class="ni ni-hat-3"></i></span>
                                <input class="form-control" placeholder="Apellido" v-model="form.apellido" ref="apellido"></input>
                            </div>
                        </div>

                        <div class="form-group input-group-alternative mb-3 input-group">
                            <div class="input-w-icon">
                                <span><i class="ni ni-email-83"></i></span>
                                <input class="form-control" type="email" placeholder="Correo" v-model="form.emailcp" ref="emailcp" @change="validateEmail"></input>
                            </div>
                            <p class="msgErrorFormatEmail" v-if="errorFormatEmail">{{ errorFormatEmail }}</p>
                        </div>
                        <div class="text-center">
                            <base-button type="primary" class="my-4 btn-block" @click="registrarContacto">Crear Cuenta</base-button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <modal :show.sync="contactCreate"
               gradient="success"
               modal-classes="modal-danger modal-dialog-centered">

            <div class="py-3 text-center">
                <i class="fa fa-check-circle ni-4x"></i>
                <h2 class="text-white text-uppercase mt-4">Creación de Usuario Exitosa!</h2>
                <p>En breves momentos le llegará su contraseña al correo registrado.</p>
            </div>

            <template slot="footer">
                <base-button type="white" class="mx-auto" @click="contactCreate = false">Cerrar</base-button>
            </template>
        </modal>
    </div>
</template>
<script>
  import {mapState, mapMutations, mapGetters, mapActions} from 'vuex'
  import store from '@/store'
  export default {
    name: 'register',
    data() {
      return {
        form: {
            company: process.env.VUE_APP_COMPANY,
            identificador: null,
            nombre: null,
            apellido: null,
            emailcp: null,
            url: process.env.VUE_APP_API_URL
        },
        errorFormatEmail: '',
        contactCreate: false
      }
    },
    methods: {
        ...mapActions('auth', ['create']),
        registrarContacto() {
            var countItems = 0
            let inputs = [
                this.$refs.identificador,
                this.$refs.nombre,
                this.$refs.apellido,
                this.$refs.emailcp                
            ]
            inputs.forEach((item) => {
                if (!item.value) {
                    item.parentElement.classList.add('isInvalid')
                    item.parentElement.classList.remove('isValid')
                    if (item.type === 'email') {
                        this.errorFormatEmail = 'Ingresar email válido.'
                    }
                } else {
                    if (item.type === 'email') {
                        item.parentElement.classList.remove('isValid')
                        if (this.validateEmail()) {
                            countItems++
                        }
                    } else {
                        item.parentElement.classList.add('isValid')
                        item.parentElement.classList.remove('isInvalid')
                        countItems++
                    }
                }
            })
            if (countItems === 4) {
                // this.form.origin = window.location.hostname
                this.form.origin = 'devportal.beaware360.com' //prueba con API de desarrollo
                this.form.lang = 'es'
                this.create(this.form)
                .then(() => {
                    this.$resetData()
                    inputs.forEach((item) => item.parentElement.classList.remove('isValid'))
                    this.contactCreate = true
                }).catch((error) => {
                    this.$notify({
                        group: 'foo',
                        title: 'Mensaje',
                        type: 'error',
                        speed: 1000,
                        duration: 500,
                        text: error.message
                    });

                    if (error.message.indexOf('Email') > -1) {
                        this.$refs.emailcp.parentElement.classList.add('isInvalid')
                    }

                    if (error.message.indexOf('Identificador') > -1) {
                        this.$refs.identificador.parentElement.classList.add('isInvalid')
                    }
                })
            } else {
                this.$notify({
                    group: 'foo',
                    title: 'Mensaje',
                    type: 'error',
                    speed: 1000,
                    duration: 500,
                    text: 'Faltan campos por completar o aceptar el acuerdo.'
                });
            }

        },
        validateEmail() {
            let email = this.$refs.emailcp.value
            let regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            if (email !== '' && !regExp.test(email)) {
                this.errorFormatEmail = 'Ingresar email válido.'
                this.$refs.emailcp.parentElement.classList.remove('isValid')
                this.$refs.emailcp.parentElement.classList.add('isInvalid')
                return false
            } else if (email !== '' && regExp.test(email)){
                this.$refs.emailcp.parentElement.classList.remove('isInvalid')
                this.$refs.emailcp.parentElement.classList.add('isValid')
                this.errorFormatEmail = ''
                return true
            } else {
                this.$refs.emailcp.parentElement.classList.remove('isValid')
                this.$refs.emailcp.parentElement.classList.remove('isInvalid')
                this.errorFormatEmail = ''
                return false
            }
        }
    }
  }
</script>
<style lang="scss">

    .vue-notification {
        margin-top: 15px;
    }

    .msgErrorFormatEmail {
        position: absolute;
        top: 44px;
        font-size: 12px;
        right: 0;
        color: #f5365c;
    }

    .input-w-icon {
        width: 100%;
        position: relative;

        span {
            position: absolute;
            left: 1rem;
            top: 0.6rem;
            color: #adb5bd;
        }

        input {
            padding-left: 3rem!important;
        }
    }

    .isValid input {
        border: 1px solid #2dce89!important;
        color: #2dce89;
    }

    .isValid:after {
        content: "\ea26";
        color: daken(#2dce89,18%);
        background-color: #69deac;
        width: 19px;
        height: 19px;
        line-height: 19px;
        text-align: center;
        font-family: NucleoIcons;
        display: inline-block;
        position: absolute;
        right: 15px;
        top: 2px;
        -webkit-transform: translateY(50%);
        transform: translateY(50%);
        border-radius: 50%;
        font-size: 9px;
        opacity: 1;
    }

    .isInvalid input {
        border: 1px solid #fb6340!important;
        color: #fb6340;
    }

    .isInvalid:after {
        content: "\ea53";
        color: daken(#fb6340,18%);
        background-color: #fda08b;
        width: 19px;
        height: 19px;
        line-height: 19px;
        text-align: center;
        font-family: NucleoIcons;
        display: inline-block;
        position: absolute;
        right: 15px;
        top: 2px;
        -webkit-transform: translateY(50%);
        transform: translateY(50%);
        border-radius: 50%;
        font-size: 9px;
        opacity: 1;
    }
</style>
